// extracted by mini-css-extract-plugin
module.exports = {"SortComponent_container":"SortComponent_SortComponent_container__3_lff","InputSelect_select":"SortComponent_InputSelect_select__1uygx"};